var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup1261153979(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.473 25.6746C22.1156 25.6746 22.6366 26.1798 22.6366 26.803C22.6366 27.4262 22.1156 27.9314 21.473 27.9314H19.1456C18.503 27.9314 17.982 27.4262 17.982 26.803C17.982 26.1798 18.503 25.6746 19.1456 25.6746H21.473ZM24.964 20.0326C25.6066 20.0326 26.1276 20.5378 26.1276 21.161C26.1276 21.7842 25.6066 22.2894 24.964 22.2894H15.6547C15.012 22.2894 14.491 21.7842 14.491 21.161C14.491 20.5378 15.012 20.0326 15.6547 20.0326H24.964ZM28.4549 14.3906C29.0976 14.3906 29.6186 14.8958 29.6186 15.519C29.6186 16.1422 29.0976 16.6474 28.4549 16.6474H12.1637C11.521 16.6474 11 16.1422 11 15.519C11 14.8958 11.521 14.3906 12.1637 14.3906H28.4549Z",
    fill: "#77B9A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1261153979);
export default __webpack_public_path__ + "static/media/Group 1261153979.007720dc46bccd1b425b5aa36809cadd.svg";
export { ForwardRef as ReactComponent };